import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';

import { ChangeIndicatedAbbreviatedNumber } from '../../../common/number';
import Text from '../../../common/text';
import { NO_DATA } from '../../../../constants';
import { injectIntl } from 'react-intl';

function AssetItemDataChange(props) {
  const { value } = props;

  if (value === null || value === undefined) {
    return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text>{NO_DATA}</Text>
      </div>
    )
  }

  if (typeof value !== 'number') {
    return null;
  }

  return (
    <ChangeIndicatedAbbreviatedNumber
      renderProps={{ size: 'large' }}
      renderExactAs="currency"
      maxDigits={7}
      value={value}
    />
  );
}

AssetItemDataChange.propTypes = {
  value: PropTypes.number,
};

AssetItemDataChange.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(AssetItemDataChange));
